import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

const STATUS_COLORS = { new: "#3AB4FF", contacted: "#FFD23F", payment_pending: "#FF8A22", approved: "#00DC82", rejected: "#F87171", activated: "#8A52FF" };

export default function AdminPlanApplications() {
  const [items, setItems] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const load = () => api.get("/admin/plan-applications").then((r) => { setItems(r.data.items); setStatuses(r.data.statuses); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/plan-applications/${id}`, { status }); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Update failed"); }
  };

  return (
    <div className="p-6 lg:p-8 max-w-[1300px] mx-auto">
      <div className="kr-overline text-[#8A52FF]">[ PLAN APPLICATIONS ]</div>
      <h1 className="font-display text-3xl mt-2 tracking-tight">Plan Applications</h1>
      <p className="text-white/50 text-sm mt-1.5">Users who applied for a plan — with required phone number and country. Includes legacy trial requests.</p>

      <div className="mt-6 kr-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-white/40 border-b border-white/5">
              {["User", "Phone", "Country", "Plan", "Company", "Notes", "Payment", "Applied", "Status"].map((h) => (
                <th key={h} className="text-left p-3 font-mono text-[10px] tracking-wider uppercase">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.application_id} className="border-b border-white/5" data-testid={`plan-app-${t.application_id}`}>
                <td className="p-3">
                  <div>{t.full_name || "—"}</div>
                  <div className="text-xs text-white/40">{t.email}{t.legacy ? " · legacy" : ""}</div>
                </td>
                <td className="p-3 font-mono text-xs" data-testid={`plan-app-phone-${t.application_id}`}>{t.phone || "—"}</td>
                <td className="p-3 text-xs">{t.country || "—"}</td>
                <td className="p-3 capitalize">{(t.plan || "").replace("_", " ")}</td>
                <td className="p-3 text-xs text-white/50">{t.company || "—"}</td>
                <td className="p-3 text-xs text-white/45 max-w-[160px] truncate">{t.notes || t.use_case || "—"}</td>
                <td className="p-3 text-xs">{t.payment_status || "—"}</td>
                <td className="p-3 text-xs text-white/45">{t.created_at ? new Date(t.created_at).toLocaleDateString() : "—"}</td>
                <td className="p-3">
                  <Select value={t.status || "new"} onValueChange={(v) => setStatus(t.application_id, v)}>
                    <SelectTrigger className="bg-[#07080B] border-white/10 h-8 w-44 text-xs" data-testid={`plan-app-status-${t.application_id}`}>
                      <span className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full" style={{ background: STATUS_COLORS[t.status || "new"] }} />
                        <SelectValue />
                      </span>
                    </SelectTrigger>
                    <SelectContent className="bg-[#101219] border-white/10">
                      {statuses.map((s) => <SelectItem key={s} value={s} className="focus:bg-white/5 capitalize">{s.replace("_", " ")}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={9} className="p-10 text-center text-white/40"><Sparkles className="h-5 w-5 mx-auto mb-2 text-white/25" />No applications yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
